<div *ngIf="salesCount > 0" class="mt-4">
  <h3 class="mat-h3">Sales</h3>
  <app-common-table [params]="params"></app-common-table>
</div>
